import { registerStoreItem, DISABLED_ACTION_COMMIT } from 'utils/storeCreator'
import {
  qingsuIndex,
  qingsuIndexQingting,
  // qingsuTeacherList,
  qingsuIndexTeacherList,
  qingsuUserMessage,
  textQingsuTeacherList,
  isQsBusinessNewUser,
  getAdLists,
  unboundTeacher,
  sendLetter,
  unreadMessageCount,
  randomOnlineList,
  //   recommendList,
  systemReply,
  newVisit,
  homeQingtingInfo,
  getTingStatus,
  qingsuIndexTeacherListV4,
  qingsuUserOwnInfo
} from 'api/qingsu'

// 倾诉首页/倾诉外部渠道首页 公用
let store = registerStoreItem({
  store: {
    namespaced: true,
    state: () => ({
      teacherList: [],
      remnderIds: null,
      filterSelect: {
        sort: 'default',
        gender: 0,
        category: 0
      },
      // 我的数据（倾诉师侧）
      myData: null,
      // 最近倾诉
      talkRecently: null,
      // 待服务语音倾诉
      voiceAwait: null,
      // 待服务文字倾诉
      textAwait: null,
      recebtlyUnbound: null,
      // 是否显示公益
      showCharity: false,
      adData: [],
      isTeacher: 0,
      userGuide: false,
      qingsuNum: 0,
      unreadMessage: 0,
      randomOnlineTeacher: null,
      recommendData: null,
      isNewVisit: 0,
      isNewTeacherVisit: 0,
      randomTeacherList: [], // 搜索页热门倾听师
      teacherSelfData: null,
      tingStatus: '',
      isQingsuStudent: 0, // 是否学员老师
      progressNum: 0, // 进行中订单数
      defaultTeacherList: [] //倾诉首页默认老师列表
    }),
    getters: {
      filterDataForIndex(state) {
        const { qingsu_tag } = state.index
        return [
          {
            type: 'tag',
            params: 'sort',
            child: [
              { key: 'default', label: '默认排序' },
              { key: 'qingnum', label: '倾诉最多' },
              { key: 'rate', label: '评价最高' }
            ],
            stat: '排序'
          },
          {
            type: 'tag',
            params: 'category',
            child: [
              { key: '', label: '方向不限' },
              ...qingsu_tag.map(item => ({
                key: item.id,
                label: item.name
              }))
            ],
            stat: '方向'
          },
          {
            type: 'tag',
            params: 'wayType',
            notSelectTitle: '倾诉方式',
            child: [
              { key: '', label: '方式不限' },
              { key: 'voice', label: '语音' },
              { key: 'text', label: '文字' }
            ],
            stat: '倾诉方式'
          },
          {
            type: 'tag',
            params: 'gender',
            child: [
              { key: '', label: '性别不限' },
              { key: '1', label: '男' },
              { key: '2', label: '女' }
            ],
            stat: '性别'
          }
        ]
      },
      filterData(state) {
        const { qingsu_tag } = state.index
        return [
          {
            type: 'tag',
            child: [
              { key: 'default', label: '默认排序' },
              { key: 'qingnum', label: '倾诉最多' },
              { key: 'rate', label: '评价最高' }
            ],
            stat: '排序'
          },
          {
            type: 'tag',
            child: [
              { key: '0', label: '方向不限' },
              ...qingsu_tag.map(item => ({
                key: item.id,
                label: item.name
              }))
            ],
            stat: '方向'
          },
          {
            type: 'tag',
            child: [
              { key: '0', label: '性别不限' },
              { key: '1', label: '男' },
              { key: '2', label: '女' }
            ],
            stat: '性别'
          }
        ]
      },
      sortFilterData(state) {
        const { qingsu_tag } = state.index
        const categories = []
        qingsu_tag.forEach(item => {
          const { name, id } = item
          if (['婚恋', '情绪', '个人成长'].includes(name)) {
            categories.push({
              ...item,
              params: 'category',
              key: id
            })
          }
        })
        return [
          {
            params: 'quickResponse',
            name: '快速响应',
            icon: 'icon-quick-reply',
            key: 1
          },
          {
            params: 'tingStatus',
            name: '现在有空',
            key: 'free'
          },
          {
            params: 'wayType',
            name: '文字倾诉',
            key: 'text'
          },
          ...categories,
          {
            params: 'isActivity',
            name: '优惠套餐',
            key: 1
          },
          {
            params: 'hasBuy',
            name: '已倾诉过',
            key: 1
          }
        ]
      },
      recommendIds(state) {
        const { recommendData } = state
        if (Array.isArray(recommendData)) {
          return recommendData.map(v => v.user_id).join(',')
        } else {
          return ''
        }
      }
    },
    mutations: {
      setNewVisit(state, isNewVisit) {
        state.isNewVisit = isNewVisit
      },
      setNewTeacherVisit(state, isNewTeacherVisit) {
        state.isNewTeacherVisit = isNewTeacherVisit
      },
      setTeacherList(state, list) {
        state.teacherList = list
      },
      setShowCharity(state, showCharity) {
        state.showCharity = showCharity
      },
      setRemnderIds(state, ids) {
        state.remnderIds = ids
      },
      setFilterSelect(state, select) {
        state.filterSelect = select
      },
      replaceBanner(state, lists) {
        state.index.banner = lists
      },
      setMyData(state, payload) {
        state.myData = payload
      },
      setTalkRecently(state, payload) {
        state.talkRecently = payload
      },
      setIsTeacher(state, payload) {
        state.isTeacher = payload
      },
      setIsUserGuide(state, payload) {
        state.userGuide = payload == 1
      },
      setAdList(state, payload) {
        state.adData = payload
      },
      setUnboundList(state, payload) {
        state.recebtlyUnbound = payload
      },
      setVoiceAwait(state, payload) {
        payload && payload.waiting
          ? (payload.waiting = {
              ...payload.waiting,
              type: 'is_voice',
              status: '待完成',
              order_id: payload ? payload.waiting.id : ''
            })
          : ''
        state.voiceAwait = payload
      },
      setTextAwait(state, payload) {
        payload && payload.waiting
          ? (payload.waiting = {
              ...payload.waiting,
              type: 'is_text',
              status: '待完成',
              order_id: payload ? payload.waiting.id : ''
            })
          : ''
        state.textAwait = payload
      },
      setQingsuNum(state, payload) {
        state.qingsuNum = +payload
      },
      setUnreadMeaasge(state, payload) {
        state.unreadMessage = payload
      },
      setRandomOnline(state, payload) {
        state.randomOnlineTeacher = payload
      },
      setRecommendList(state, payload) {
        state.recommendData = payload || []
      },
      setTingStatus(state, payload) {
        state.tingStatus = payload || ''
      },
      setSystemReply() {},
      setRandomTeacherList(state, payload) {
        state.randomTeacherList = payload
      },
      setMySelf(state, payload) {
        state.teacherSelfData = payload
      },
      setQingsuStudent(state, payload) {
        state.isQingsuStudent = payload
      },
      setProgressNum(state, payload) {
        state.progressNum = payload
      },
      setDefaultTeacherList(state, payload) {
        state.defaultTeacherList = payload
      }
    },
    actions: {
      fetchIsNewVisit({ commit }, params) {
        return newVisit(params).then(res => {
          if (res.code === 0) {
            const { is_new_visit, is_new_teacher_visit } = res.data
            commit('setNewVisit', is_new_visit)
            commit('setNewTeacherVisit', is_new_teacher_visit)
          }
        })
      },
      // 语音倾诉tab下的倾诉师列表
      fetchTeacherList({ commit, state }, params) {
        const { randomSort, ...other } = params
        return qingsuIndexTeacherList({
          ...other
        }).then(res => {
          if (res.code === 0) {
            if (randomSort) {
              commit('setRandomTeacherList', res.data)
            } else {
              params.page === 1
                ? commit('setTeacherList', res.data)
                : commit('setTeacherList', [...state.teacherList, ...res.data])
            }

            //   console.log(8888888, res.is_show_charity,res.is_new_business_user)
            //
            // commit(
            //   'setShowCharity',
            //   res.is_show_charity > 0 && res.is_new_business_user > 0
            // )
            return res.data
          }
        })
      },

      async fetchTeacherListOnAndOffline({ commit, state }, params) {
        const { ting_status, page } = params
        let teacherList = page === 1 ? [] : [...state.teacherList]
        // if (page === 1) {
        //   const recommendData = await qingsuIndexTeacherList({
        //     cid: params.cid,
        //     type: 'recommend'
        //   })

        //   if (recommendData.code === 0) {
        //     teacherList = [...teacherList, ...recommendData.data]
        //   }
        // }
        if (page === 1 && ting_status === 'offline') {
          // 请求在线/非在线
          const onlineData = await qingsuIndexTeacherList({
            ...params,
            ting_status: 'online'
          })

          if (onlineData.code === 0) {
            teacherList = [...teacherList, ...onlineData.data]
          }
        }

        const nomalData = await qingsuIndexTeacherList({
          ...params
        })

        if (nomalData.code === 0) {
          teacherList = [...teacherList, ...nomalData.data]
        }

        commit('setTeacherList', teacherList)

        return nomalData.data
      },

      fetchTeacherListV4({ commit, state }, params) {
        const { type, pageNo } = params
        return qingsuIndexTeacherListV4({
          ...params
        }).then(res => {
          if (res.code === 0) {
            // 全部返回 不支持分页
            if (type === 'recommend') {
              commit('setDefaultTeacherList', res.data)
            } else {
              pageNo === 1
                ? commit('setTeacherList', res.data)
                : commit('setTeacherList', [...state.teacherList, ...res.data])
            }
            return res.data
          }
        })
      },
      fetchUserOwnInfo({ commit }, params) {
        return qingsuUserOwnInfo(params).then(res => {
          if (res.code === 0) {
            const { expandInfo = {} } = res.data
            const { is_new_business_user, is_show_charity } = expandInfo
            const showCharity = params.cid
              ? is_show_charity > 0
              : is_new_business_user > 0 && is_show_charity > 0
            commit('setShowCharity', showCharity)
            commit('setMySelf', res.data)
            return res.data
          }
        })
      },

      // 是否倾诉新用户
      fetchIsQsBusinessNewUser({ commit }, params) {
        return isQsBusinessNewUser(params).then(res => {
          if (res.code === 0) {
            const { is_new_business_user, is_show_charity } = res.data
            const showCharity = params.cid
              ? is_show_charity > 0
              : is_new_business_user > 0 && is_show_charity > 0
            commit('setShowCharity', showCharity)
            return res.data
          }
        })
      },
      // 文字倾诉tab下的倾诉师列表
      fetchTextQingsuTeacherList({ commit, state }, params) {
        return textQingsuTeacherList(params).then(res => {
          if (res.code === 0) {
            // 转换数据格式
            let tmpData = res.data || []
            // tmpData = tmpData.map(v => {
            //   v.nickname = v.name // 倾诉师昵称
            //   v.categorys = v.tags // 擅长领域
            //   v.qingnum = v.num // 倾诉人次
            //   v.zizhi = v.honor // 资质，例如：国家二级咨询师
            //   return v
            // })

            params.page === 1
              ? commit('setTeacherList', tmpData)
              : commit('setTeacherList', [...state.teacherList, ...tmpData])

            return tmpData
          }
        })
      },
      fetchNewTeacherList({ commit, dispatch }, params) {
        commit('setFilterSelect', params)
        dispatch('fetchTeacherList')
      },
      fetchUserMessage({ commit }, params = {}) {
        return qingsuUserMessage(params).then(res => {
          const { data = {}, code } = res
          if (code === 0) {
            const {
              my_data,
              talk_recently,
              is_teacher,
              user_guide,
              text_waiting,
              voice_waiting,
              qingsu_num,
              qingsu_student,
              progress_num
            } = data
            if (my_data) {
              my_data.__fetchTime = new Date().getTime()
            }
            commit('setMyData', my_data)
            commit('setTalkRecently', talk_recently)
            commit('setIsTeacher', is_teacher)
            commit('setIsUserGuide', user_guide)
            commit('setVoiceAwait', voice_waiting)
            commit('setTextAwait', text_waiting)
            commit('setQingsuNum', qingsu_num)
            commit('setQingsuStudent', qingsu_student)
            commit('setProgressNum', progress_num)
            return data
          }
        })
      },
      getAdList({ commit }, params) {
        return getAdLists(params).then(res => {
          if (res.code === 0) {
            commit('setAdList', res.data)
            return res.data
          }
        })
      },
      getUnboundTeacher({ commit }) {
        return unboundTeacher().then(res => {
          const { data = {}, code } = res
          if (code === 0) {
            commit('setUnboundList', data)
            return data
          }
        })
      },
      sendLetter({ commit }, params) {
        console.log(commit)
        return sendLetter(params).then(res => {
          const { code } = res
          if (code === 0) {
            return
          }
        })
      },
      getUnreadMessage({ commit }) {
        return unreadMessageCount().then(res => {
          const { data = {}, code } = res
          if (code === 0) {
            commit('setUnreadMeaasge', data)
            return data
          }
        })
      },
      getRandomOnlineList({ commit }) {
        return randomOnlineList().then(res => {
          const { data = {}, code } = res
          if (code === 0) {
            commit('setRandomOnline', data)
            return data
          }
        })
      },
      // 新排序接口首批老师数量不定，分开请求避免影响分页
      getRecommendList({ commit }, params) {
        return qingsuIndexTeacherList(params).then(res => {
          const { data = [], code } = res
          if (code === 0) {
            commit('setRecommendList', data)
            return data
          } else {
            return []
          }
        })
      },
      getTingStatus({ commit }, params) {
        return getTingStatus(params).then(res => {
          const { data = [], code } = res
          console.log(data)
          if (code === 0) {
            commit('setTingStatus', data?.ting_status || '')
            return data
          } else {
            return []
          }
        })
      },
      systemReply({ commit }, params) {
        return systemReply(params).then(res => {
          const { data = {}, code } = res
          if (code === 0) {
            commit('setSystemReply', data)
            return data
          }
        })
      },
      getMySelf({ commit }) {
        return homeQingtingInfo().then(res => {
          const { data, code } = res
          if (code === 0) {
            commit('setMySelf', data)
            return data
          }
        })
      }
    }
  },

  name: 'index',
  api: qingsuIndex,
  handle: res => {
    if (res.code !== 0) {
      return DISABLED_ACTION_COMMIT
    }
    return res.data
  },
  defaultValue: {
    topic: {},
    channel_banner: [],
    qingsu_tag: [],
    banner: [],
    qingsu_topic: []
  }
})

store = registerStoreItem({
  store: store,
  name: 'qingting',
  api: qingsuIndexQingting,
  handle: res => {
    if (+res.code === 40001) {
      let data = {
        discount_info: {
          activity: 0,
          firstOrder: 1
        },
        activity_time: {
          can_use_extral_duration: false
        }
      }
      if (res.data && res.data.activity_time) {
        data.activity_time = res.data.activity_time
      }
      return data
    }
    if (res.code !== 0) {
      return DISABLED_ACTION_COMMIT
    }
    return res.data
  },
  defaultValue: {
    discount_info: {
      activity: 0,
      firstOrder: 1
    }
  }
})

export default {
  name: 'qingsuindex',
  store
}
